<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template #headAction>
        <a-button type="primary" class="ml" @click="getTableQRCode"
          >获取点餐二维码</a-button
        >
      </template>
    </data-table>

    <a-modal
      centered
      :title="'桌台【' + selectRow.Name + '】点餐二维码'"
      v-model="visible"
      @cancel="visible = false"
      @ok="visible = false"
      :maskClosable="false"
      :destroyOnClose="true"
      width="350px"
      :footer="null"
    >
      <div class="qr-code-box">
        <div>
          是否彩色：
          <a-switch v-model="IsMultiColour" @change="changeQrCode"></a-switch>
        </div>
        <p><img :src="tableQRCode" alt="桌台二维码" /></p>
        <p>请将二维码图片保存到电脑后打印</p>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      tableQRCode: "",
      visible: false,
      IsMultiColour: true,
      selectRow: {},
      content: [
        {
          label: "台号",
          name: "Code",
          option: {
            rules: [{ required: true, message: "台号必填" }]
          },
          onBlur: e => {
            const val = e.target.value;
            if (this.$refs.dataTable) {
              const data = this.$refs.dataTable.getFormData();
              if (!data.Name) {
                this.$refs.dataTable.setFormData({
                  ...data,
                  Name: val
                });
              }
            }
          }
        },
        {
          label: "名称",
          name: "Name",
          option: {
            rules: [{ required: true, message: "名称必填" }]
          }
        },
        {
          label: "座位数",
          name: "Seat",
          type: "number",
          props: {
            min: 0
          }
        },
        {
          label: "是否虚拟台",
          name: "IsVirtual",
          type: "checkbox"
        },
        {
          label: "状态",
          name: "OtherStatus",
          type: "switch"
        },
        {
          label: "排序",
          name: "Sort",
          type: "number",
          props: {
            min: 0
          }
        }
      ]
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "名称",
            name: "Name"
          },
          {
            label: "桌台号",
            name: "Code"
          }
        ]
      },
      form: {
        title: "桌台",
        width: 500,
        colnum: 1,
        content: this.content,
        add: {
          submitApi: "AddTable",
          onOpenAfter: () => {
            let values = {
              Sort: "0",
              Seat: "0",
              IsVirtual: false,
              OtherStatus: true
            };
            return values;
          },
          onSubmitBefore: values => {
            values.OtherStatus = values.OtherStatus ? 1 : 0;
            return values;
          }
        },
        edit: {
          submitApi: "EditTable",
          onOpenAfter: values => {
            values.OtherStatus = values.OtherStatus ? true : false;
            return values;
          },
          onSubmitBefore: values => {
            values.OtherStatus = values.OtherStatus ? 1 : 0;
            return values;
          }
        },
        del: {
          submitApi: "DeleteTable",
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      grid: {
        api: "GetTableList",
        dataField: "Data",
        pagination: false,
        props: {
          scroll: {
            x: 1250,
            y: "calc(100vh - 200px)"
          }
        },
        columns: [
          {
            title: "序号",
            width: 80,
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "名称",
            dataIndex: "Name"
          },
          {
            title: "桌台号",
            width: 150,
            dataIndex: "Code"
          },
          {
            title: "座位数",
            width: 100,
            dataIndex: "Seat"
          },
          {
            title: "桌台状态",
            width: 100,
            dataIndex: "Status",
            customRender: (text, record) => {
              if (text == 1) {
                return <a-badge status="processing" text={record.StatusName} />;
              } else if (text == 2) {
                return <a-badge status="success" text={record.StatusName} />;
              } else {
                return <a-badge status="error" text={record.StatusName} />;
              }
            }
          },
          {
            title: "清洁状态",
            width: 150,
            dataIndex: "ClearStatus",
            customRender: (text, record) => {
              if (text) {
                return (
                  <a-badge status="success" text={record.ClearStatusName} />
                );
              } else {
                return <a-badge status="error" text={record.ClearStatusName} />;
              }
            }
          },
          {
            title: "状态",
            width: 120,
            dataIndex: "OtherStatus",
            customRender: (text, record) => {
              if (text) {
                return (
                  <a-badge status="success" text={record.OtherStatusName} />
                );
              } else {
                return <a-badge status="error" text={record.OtherStatusName} />;
              }
            }
          },
          {
            title: "是否虚拟台",
            width: 150,
            dataIndex: "IsVirtual",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="是" />;
              } else {
                return <a-badge status="error" text="否" />;
              }
            }
          },
          {
            title: "排序",
            width: 100,
            dataIndex: "Sort"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: 150,
            fixed: "right",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    getTableQRCode() {
      const row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.error("请先选择生产二维码的桌台");
        return false;
      }
      this.selectRow = row;
      this.changeQrCode();
    },
    changeQrCode() {
      this.$post("GetTableQRCode", {
        Id: this.selectRow.Id,
        IsMultiColour: this.IsMultiColour
      }).then(res => {
        this.tableQRCode = "data:image/jpeg;base64," + res.Data.QRCode;
        this.visible = true;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.qr-code-box {
  padding: 10px 10px 20px;
  text-align: center;
  & > p {
    margin-top: 10px;
  }
}
</style>
